module.exports = __webpack_public_path__ + "static/img/poster_1.4ef12dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/poster_1.jpg
// module id = PFc2
// module chunks = 0